if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();

        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        this.querySelectorAll('video').forEach((video) => video.play());
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
          if (element.nodeName == 'DEFERRED-MEDIA') {
            const elementMediaTemplate = element.querySelector('template');
            const elementMediaContent = elementMediaTemplate ? elementMediaTemplate.content : null;
            if (elementMediaContent) {
              element.loadContent();
            }
          }
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA'
          && activeMediaContent
          // && activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
